module.exports = __webpack_public_path__ + "img/horizontal_3_4_8011.40d9c098.png";